import { userPreferences } from '#packages/stateManagement';
import _ from 'lodash';

import type {
  Dispatch,
  MapDispatchToPropsFunction,
  MapStateToProps,
} from 'types/redux';
import type {
  AiAssistantDispatchProps,
  AiAssistantOwnProps,
  AiAssistantStateProps,
} from './aiAssistantTypes';
import { META_SITE_APPLICATION_ID } from './constants';
export const IS_FIRST_ASSISTANT_MESSAGE = 'IS_FIRST_ASSISTANT_MESSAGE';

export const mapStateToProps: MapStateToProps<
  AiAssistantStateProps,
  AiAssistantOwnProps
> = ({ editorAPI, state }) => {
  const isFirstMessage: boolean = _.defaultTo(
    userPreferences.selectors.getSessionUserPreferences(
      IS_FIRST_ASSISTANT_MESSAGE,
    )(state),
    true,
  );

  return {
    isFirstMessage,
    appToken: editorAPI.platform.getAppDataByApplicationId(
      META_SITE_APPLICATION_ID,
    )?.instance,
  };
};

export const mapDispatchToProps: MapDispatchToPropsFunction<
  AiAssistantDispatchProps,
  AiAssistantOwnProps
> = (dispatch: Dispatch) => {
  const setToUserPreferences = (key: string, value: boolean) => {
    dispatch(userPreferences.actions.setSessionUserPreferences(key, value));
  };

  return { setToUserPreferences };
};
